module.exports = __webpack_public_path__ + "img/text_file_icon.54983d2b.svg";